import { giveaway } from "@/content/site";
import { asset } from "@/lib/assets";

export function PrizeCard() {
  return (
    <div className="flex h-full flex-col rounded-2xl bg-white/85 p-6 backdrop-blur-sm sm:p-8 lg:p-10">
      <p className="font-roboto text-xs uppercase tracking-[0.25em] text-brand-blue/70">Sorteio</p>

      <h2 className="mt-2 text-[clamp(2.75rem,7vw,4.5rem)] font-extrabold italic uppercase leading-none text-brand-blue">Prémio</h2>

      <img
        className="mx-auto my-6 w-full max-w-sm lg:my-8"
        src={asset("images/webp/desktop.webp")}
        alt="PC do sorteio"
        loading="lazy"
        decoding="async"
      />

      {/* Specs read better as chips than as four lines squeezed into a circle. */}
      <ul className="flex flex-wrap justify-center gap-2">
        {giveaway.specs.map((spec) => (
          <li key={spec} className="rounded-full bg-brand-blue/10 px-4 py-1.5 font-roboto text-sm font-bold text-brand-deep sm:text-base">
            {spec}
          </li>
        ))}
      </ul>

      {/* The margin below this copy sets the gap above the rule; `mt-auto` only
          absorbs leftover card height on top of it. */}
      <p className="mt-6 mb-8 text-lg/relaxed font-medium text-brand-deep lg:mt-8 lg:mb-10 lg:text-xl">
        Cada ticket que ganhas na roda da sorte é uma entrada no sorteio. Quantos mais juntares, maior a hipótese de levares o PC para casa.
      </p>

      <div className="mt-auto border-t border-brand-deep/10 pt-5 lg:pt-6">
        <p className="text-xl font-extrabold text-brand-blue lg:text-2xl">
          Termina a <time dateTime={giveaway.endsAt}>{giveaway.endsAtLabel}</time>
        </p>
        <p className="mt-2 text-sm/relaxed text-brand-deep/60 lg:text-base">
          A data pode ser ajustada para agendarmos a livestream onde é sorteado o vencedor.
        </p>
      </div>
    </div>
  );
}
